import { setBanners } from "../home_action"
import { homeApi } from "../home_api"

export const getBanners = async (dispatch:any) => {

    const res = await homeApi.getBanners({})
    dispatch(setBanners(res.data))
  }